import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonComp } from 'atoms/Buttons';
import { SearchAddressForm } from './SearchAddressForm';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
const { Error } = IMAGE_PATH;

const ConfirmSearchAddressComp = props => {
  const { showConfirmBtn = false } = props;
  const { CONFIRM_BTN_TEXT } = TRANSLATE_MAPPING_KEY;

  return (
    <React.Fragment>
      <div className='delivery-address-section'>
        <SearchAddressForm {...props}></SearchAddressForm>
        {showConfirmBtn && (
          <form>
            <ButtonComp
              className='button blackButton blackBorder delivery-confirm-button'
              data-testid='btn-confirm'
              disabled={!props.confirm}
              onClick={props.onAddressConfirmHandler}
            >
              {translateWithI18Next(CONFIRM_BTN_TEXT)}
            </ButtonComp>
          </form>
        )}
      </div>
      <div className='placesautocomplete-border'></div>
      <span className='d-none'>
        <ImageComponent srcFile={Error} className='location-alert-icon' />
      </span>
    </React.Fragment>
  );
};

export const ConfirmSearchAddress = React.memo(ConfirmSearchAddressComp);
